import { Dropdown } from 'flowbite-react'
import Link from 'next/link'
import React from 'react'

type Route = {
  title: string
  route: string
  target?: string
}

type MenuSection = {
  title?: string
  routes?: Route[]
  separator?: boolean
}

type HeaderMenuProps = {
  sections: MenuSection[]
  onClose?: () => void
  userInitials?: string
  variant?: 'mobile' | 'dropdown'
}

export const HeaderMenu = ({
  sections,
  onClose,
  userInitials,
  variant = 'mobile',
}: HeaderMenuProps) => {
  if (variant === 'dropdown') {
    return (
      <Dropdown
        label=""
        dismissOnClick={false}
        placement="bottom-end"
        className="grid min-w-[240px] rounded-2xl bg-white/90 backdrop-blur"
        renderTrigger={() => (
          <span className="hidden h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-mydra-black text-lg font-bold text-white md:flex">
            {userInitials}
          </span>
        )}
      >
        {sections.map(
          ({ routes }) =>
            Array.isArray(routes) &&
            routes.length > 0 &&
            routes.map(({ title, route, target }, index) => (
              <Link
                href={route}
                className="focus:outline-none"
                key={index}
                target={target}
              >
                <Dropdown.Item className="px-4 py-3 text-mydra-black hover:bg-mydra-purple-light focus:bg-mydra-purple-light">
                  {title}
                </Dropdown.Item>
              </Link>
            ))
        )}
      </Dropdown>
    )
  }

  return (
    <div className="container grid grid-cols-2 gap-8 p-4 pt-6">
      {sections.map(({ title, routes, separator }, index) =>
        separator ? (
          <div
            key={`separator-${index}`}
            className="col-span-2 h-px w-full bg-[--lines]"
          />
        ) : (
          routes &&
          routes.length > 0 && (
            <React.Fragment key={title}>
              <div className="flex flex-col gap-4">
                <div className="font-regular font-title text-sm text-gray-light">
                  {title}
                </div>
                {routes.map(({ title, route, target }) => (
                  <Link
                    href={route}
                    className="focus:outline-none"
                    key={route}
                    target={target}
                    onClick={onClose}
                  >
                    <div className="flex items-center gap-4 text-base font-medium text-mydra-black">
                      <span>{title}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </React.Fragment>
          )
        )
      )}
    </div>
  )
}
